<div class="sg-flex-row sg-justify-start sg-items-center sg-gap-16">
  @if (nForm$ | async | sgNegate) {
  <div class="sg-flex-row sg-justify-start sg-items-center sg-gap-16">
    <span>Entity: Not Attached</span>
    <button mat-icon-button color="primary" (click)="attachEntity()" matTooltip="Attach Entity"><mat-icon>link</mat-icon></button>
  </div>
  } @if (nForm$ | async; as f) { @if (f && f.model) {
  <pbl-nform
    #form
    [model]="f.model"
    formClass="sg-horizontal-form"
    [disabledState]="disabledControls"
    (beforeRender)="beforeFormQueryRender($event, form)"
    (valueChanges)="valueChanges($event)">
    <div *nFormOverride="'*'; let ctx" class="sg-horizontal-form-control">
      <ng-container *ngTemplateOutlet="renderer; context: { $implicit: ctx, dynForm: form }"></ng-container>
    </div>
  </pbl-nform>
  <button mat-icon-button color="warn" (click)="detachEntity()" matTooltip="Detach Entity"><mat-icon>link_off</mat-icon></button>
  } }
</div>
<ng-template #renderer let-ctx let-dynForm="dynForm">
  <material-form-control-renderer
    [nFormCmp]="dynForm"
    [nForm]="ctx.nForm"
    [fArray]="ctx.fArray"
    [fControl]="ctx.fControl"
    [fGroup]="ctx.fGroup"
    [item]="ctx.item"></material-form-control-renderer>
</ng-template>
